<template>
  <div data-cy="card-item" class="card-item shadowless">
    <div class="card-item-header">
      <div class="transaction-header-resume">
        <div class="transaction-header-amount">
          <span
            :id="`${transaction._id}-amount`"
            class="content-title">
            Monto:
          </span>
          <span
            :id="`${transaction._id}-amount`">
            {{ `${ $i18n.locale === 'cl' ? '$' : 'S/'} ${formatNumber(transaction.debtAmount)}` }}
          </span>
        </div>
        <div class="transaction-header-payments">
          <span class="content-title">{{ `Cuota${transactionPayments.length > 1 ? 's' : ''}: ` }} </span>
          <div
            v-for="operation in transaction.selectedPayments"
            :key="operation.companyOperationId">
            <b-tooltip
              v-for="payment in operation.payments"
              :key="payment.paymentNumber"
              position="is-right"
              type="is-light">
              <template #content>
                <div>
                  <div class="is-pulled-left"><span><b>Crédito:</b> {{ operation.companyOperationId }}</span></div>
                  <div class="is-pulled-left"><span><b>Vencimiento:</b> {{ dateToFormatedString(payment.dueDate, 'DD MMMM YYYY').toLowerCase() }}</span></div>
                  <div v-if="!currentUserIsClient" class="is-pulled-left"><span><b>Inversionista:</b> {{ payment.investorName }} </span></div>
                </div>
              </template>
              <span class="content-value transaction-header-payment">{{ `${payment.paymentNumber}` }}</span>
            </b-tooltip>
          </div>
        </div>
        <div class="transaction-header-payed">
          <span class="content-title">Fecha de pago: </span>
          <span>{{ formatDate(transaction.createdAt, 'DD/MM/YYYY') }}</span>
        </div>
        <div class="transaction-header-status">
          <b-tooltip label="Estado del pago" position="is-bottom" type="is-light">
            <div class="tag med-size-text" :class="`${transaction.status.toLowerCase()}`">
              {{ transaction.statusTranslation }}
            </div>
          </b-tooltip>
        </div>
      </div>
      <div v-if="$i18n.locale==='cl'" class="transaction-header-details">
        <a :id="`extend-${transaction._id}`" href="#" @click.prevent="$emit('extend-transaction', transaction._id)">
          <span class="fa" :class="isExtended ? 'fa-minus-circle' : 'fa-plus-circle'" />
        </a>
      </div>
    </div>
    <div class="card-item-details clearfix transition-slow" :class="{ show: isExtended }">
      <div data-cy="details-header" class="details-header">
        <span>
          <span class="has-text-weight-bold">Medio de pago: </span>
          <span>{{ transaction.providerTranslation }}</span>
        </span>
        <span>
          <span class="has-text-weight-bold">UF el día del pago: </span>
          <span>{{ ` $ ${formatNumber(transaction.secondaryCurrencyFactor)}` }}</span>
        </span>
      </div>
      <div v-for="operation in transaction.selectedPayments" :key="operation.companyOperationId" data-cy="selected-operation" class="selected-operation">
        <span class="med-size-text">
          <span class="gloss-credit">
            <b-tooltip
              :label="`Número de operación crédito ${ getOperationTypeTitle(operation.type) }`"
              size="is-small"
              type="is-white"
              multilined>
              <span v-if="operation.type === 'MORTGAGE'">🏡</span>
              <span v-if="operation.type === 'COMPLEMENTARY'">💰</span>
              <span v-if="operation.type === 'PARKING'">🅿️</span>
              <span class="has-text-weight-bold"> Nº </span> {{ operation.companyOperationId }}
            </b-tooltip>

          </span>
        </span>
        <div class="selected-payment-details">
          <div class="gloss">
            <span class="gloss-payment has-text-weight-bold">Cuota</span>
            <!-- <span class="gloss-title has-text-weight-bold">Glosa</span> -->
            <span class="gloss-monetary-sign has-text-weight-bold">
              <b-field v-if="operation.type !== 'COMPLEMENTARY'" grouped>
                <b-switch :data-cy="`ufSwitch-${operation.paymentsNumbers}`" size="is-small" @input="updateMonetarySignShowing({ uf: $event })">
                  <span class="has-text-weight-bold"> UF </span>
                </b-switch>
              </b-field>
            </span>
          </div>
        </div>
        <div
          v-for="payment in operation.payments"
          :key="payment.paymentNumber"
          class="selected-payment"
          :class="extendedPayment===`${operation.companyOperationId}-${payment.paymentNumber}` ? 'show' : ''">
          <div class="selected-payment-details">
            <div class="gloss" :class="extendedPayment===`${operation.companyOperationId}-${payment.paymentNumber}` ? 'show has-text-weight-bold' : ''">
              <span class="gloss-payment">{{ payment.paymentNumber }}</span>
              <span class="gloss-title">Total</span>
              <span v-if="monetarySignShowing === 'UF'" class="gloss-monetary-sign">{{ formatNumber(payment.totalMonthlyPayment) }}</span>
              <span v-if="monetarySignShowing === 'CLP'" class="gloss-monetary-sign">{{ `$ ${formatNumber(payment.secondaryCurrencyTotalMonthlyPayment) }` }}</span>
              <a
                :id="`extend-${operation.companyOperationId}-${payment.paymentNumber}`"
                class="gloss-button"
                href="#"
                @click.prevent="extendPayment(`${operation.companyOperationId}-${payment.paymentNumber}`)">
                <span class="fa" :class="extendedPayment === `${operation.companyOperationId}-${payment.paymentNumber}` ? 'fa-minus-circle' : 'fa-plus-circle'" />
              </a>
            </div>
            <div class="detail-glosses clearfix transition-slow" :class="extendedPayment===`${operation.companyOperationId}-${payment.paymentNumber}` ? 'show' : 'hide'">
              <div
                v-if="payment.amortization"
                class="gloss">
                <span class="gloss-title">Amortización</span>
                <span v-if="monetarySignShowing === 'UF'" class="gloss-monetary-sign">{{ formatNumber(payment.amortization) }}</span>
                <span v-if="monetarySignShowing === 'CLP'" class="gloss-monetary-sign">$ {{ formatNumber(payment.secondaryCurrencyAmortization) }}</span>
              </div>
              <div
                v-if="payment.interest"
                class="gloss">
                <span class="gloss-title">Interés</span>
                <span v-if="monetarySignShowing === 'UF'" class="gloss-monetary-sign">{{ formatNumber(payment.interest) }}</span>
                <span v-if="monetarySignShowing === 'CLP'" class="gloss-monetary-sign">$ {{ formatNumber(payment.secondaryCurrencyInterest) }}</span>
              </div>
              <div
                v-if="payment.monthlyDebtorLifeInsurance"
                class="gloss">
                <span class="gloss-title">Desgravamen</span>
                <span v-if="monetarySignShowing === 'UF'" class="gloss-monetary-sign">{{ formatNumber(payment.monthlyDebtorLifeInsurance) }}</span>
                <span v-if="monetarySignShowing === 'CLP'" class="gloss-monetary-sign">$ {{ formatNumber(payment.secondaryCurrencyMonthlyDebtorLifeInsurance) }}</span>
              </div>
              <div
                v-if="payment.monthlyCodebtorLifeInsurance"
                class="gloss">
                <span class="gloss-title">Desg. codeudor</span>
                <span v-if="monetarySignShowing === 'UF'" class="gloss-monetary-sign">{{ formatNumber(payment.monthlyCodebtorLifeInsurance) }} </span>
                <span v-if="monetarySignShowing === 'CLP'" class="gloss-monetary-sign">$ {{ formatNumber(payment.secondaryCurrencyMonthlyCodebtorLifeInsurance) }}</span>
              </div>
              <div
                v-if="payment.monthlyFireInsurance"
                class="gloss">
                <span class="gloss-title">Seguro de incendio</span>
                <span v-if="monetarySignShowing === 'UF'" class="gloss-monetary-sign">{{ formatNumber(payment.monthlyFireInsurance) }}</span>
                <span v-if="monetarySignShowing === 'CLP'" class="gloss-monetary-sign">$ {{ formatNumber(payment.secondaryCurrencyMonthlyFireInsurance) }}</span>
              </div>
              <div
                v-if="!!payment.monthlyCreditInsurance"
                class="gloss">
                <span class="gloss-title">Seguro de crédito</span>
                <span v-if="monetarySignShowing === 'UF'" class="gloss-monetary-sign">{{ formatNumber(payment.monthlyCreditInsurance) }}</span>
                <span v-if="monetarySignShowing === 'CLP'" class="gloss-monetary-sign">$ {{ formatNumber(payment.secondaryCurrencyMonthlyCreditInsurance) }}</span>
              </div>
              <div
                v-if="!!payment.monthlyCreditInsurancePrize"
                class="gloss">
                <span class="gloss-title">Seguro de crédito (Premio)</span>
                <span v-if="monetarySignShowing === 'CLP'" class="gloss-monetary-sign">$ {{ formatNumber(payment.monthlyCreditInsurancePrize) }}</span>
              </div>
              <div
                v-if="!!payment.monthlyCreditInsuranceExpenses"
                class="gloss">
                <span class="gloss-title">Seguro de crédito (Costo)</span>
                <span v-if="monetarySignShowing === 'CLP'" class="gloss-monetary-sign">$ {{ formatNumber(payment.monthlyCreditInsuranceExpenses) }}</span>
              </div>
              <div
                v-if="payment.lateInterest"
                class="gloss">
                <span class="gloss-title">Interés penal</span>
                <span v-if="monetarySignShowing === 'UF'" class="gloss-monetary-sign">{{ formatNumber(payment.lateInterest) }}</span>
                <span v-if="monetarySignShowing === 'CLP'" class="gloss-monetary-sign">$ {{ formatNumber(payment.secondaryCurrencyLateInterest) }}</span>
              </div>
              <div
                v-if="payment.lateCharges"
                class="gloss">
                <span class="gloss-title">Gastos de cobranza</span>
                <span v-if="monetarySignShowing === 'UF'" class="gloss-monetary-sign">{{ formatNumber(payment.lateCharges) }}</span>
                <span v-if="monetarySignShowing === 'CLP'" class="gloss-monetary-sign">$ {{ formatNumber(payment.secondaryCurrencyLateCharges) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$i18n.locale==='cl'" class="card-item-details clearfix transition-slow" :class="{ show: isExtended }">
      <div class="details-header">
        <span>
          <span class="has-text-weight-bold">Valor total cuotas seleccionadas: </span>
          <span
            :id="`${transaction._id}-detail-amount`">
            $ {{ formatNumber(transaction.debtAmount) }}
          </span>
        </span>
      </div>
      <div class="details-header">
        <span>
          <span class="has-text-weight-bold">Saldo de billetera utilizado: </span>
          <span
            :id="`${transaction._id}-wallet-amount`">
            $ {{ formatNumber(transaction.usedClientBalance) }}
          </span>
        </span>
      </div>
      <div class="details-header">
        <span>
          <span class="has-text-weight-bold">Monto a pagar: </span>
          <span
            :id="`${transaction._id}-amount-to-pay`">
            $ {{ formatNumber(transaction.amount) }}
          </span>
        </span>
      </div>
      <div v-if="transaction.receivedAmount" class="details-header">
        <span>
          <span class="has-text-weight-bold">Monto recibido: </span>
          <span
            :id="`${transaction._id}-received-amount`">
            $ {{ formatNumber(transaction.receivedAmount) }}
          </span>
        </span>
      </div>
      <div v-if="transaction.status==='REJECTED' || transaction.status==='FAIL' || transaction.status==='CANCELLED'" class="details-header">
        <span v-if="transaction.receivedAmount">
          <span class="has-text-weight-bold">Saldo generado: </span>
          <span
            :id="`${transaction._id}-generated-balance`">
            $ {{ formatNumber(transaction.receivedAmount + transaction.usedClientBalance) }}
          </span>
        </span>
        <span v-else>
          <span class="has-text-weight-bold">Saldo generado: </span>
          <span
            :id="`${transaction._id}-generated-balance`">
            $ {{ formatNumber(transaction.usedClientBalance) }}
          </span>
        </span>
      </div>
      <div v-if="transaction.status==='CONFIRMED' || transaction.status==='CONSIGNABLE'" class="details-header">
        <span>
          <span class="has-text-weight-bold">Saldo generado: </span>
          <span
            :id="`${transaction._id}-generated-balance`">
            $ {{ formatNumber(transaction.receivedAmount - transaction.amount) }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { dateToFormatedString } from '@/infrastructure/date';
import { formatNumber } from '@/infrastructure/format';

export default {
  props: {
    currentUserIsClient: { type: Boolean, default: false },
    isExtended: { type: Boolean, default: false },
    transaction: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      monetarySignShowing: 'CLP',
      extendedPayment: '',
      paymentDetails: {
        amortization: { translate: 'Amortización', secondaryCurrency: 'secondaryCurrencyAmortization' },
        interest: { translate: 'Interés', secondaryCurrency: 'secondaryCurrencyInterest' },
        monthlyDebtorLifeInsurance: { translate: 'Seguro desgravamen deudor', secondaryCurrency: 'secondaryCurrencyMonthlyDebtorLifeInsurance' },
        monthlyCodebtorLifeInsurance: { translate: 'Seguro desgravamen codeudor', secondaryCurrency: 'secondaryCurrencyMonthlyCodebtorLifeInsurance' },
        monthlyFireInsurance: { translate: 'Seguro de incendio', secondaryCurrency: 'secondaryCurrencyMonthlyFireInsurance' },
        lateInterest: { translate: 'Interés penal', secondaryCurrency: 'secondaryCurrencyLateInterest' },
        lateCharges: { translate: 'Gastos de cobranza', secondaryCurrency: 'secondaryCurrencyLateCharges' }
      }
    };
  },
  computed: {
    transactionPayments() {
      return this.transaction.selectedPayments.reduce((acc, selectedPayment) => {
        return acc.concat(selectedPayment.paymentsNumbers);
      }, []);
    }
  },
  methods: {
    getOperationTypeTitle(type) {
      return {
        MORTGAGE: `🏡 ${this.$t('mortgage')}`,
        COMPLEMENTARY: `💰 ${this.$t('complementary')}`,
        HOME_EQUITY: `🏡 ${this.$t('homeEquity')}`,
        PARKING: `🅿️ ${this.$t('parking')}`,
        SME: `🚀 ${this.$t('sme')}`
      }[type];
    },
    formatNumber: number => formatNumber({ number, maxDecimals: 6 }),
    dateToFormatedString: (date, format) => dateToFormatedString(date, format),
    formatDate(date, format) {
      if (this.$i18n.locale === 'pe') {
        return new Date(date)
          .toISOString()
          .slice(0, 10)
          .split('-')
          .reverse()
          .join('/');
      }
      return dateToFormatedString(date, format);
    },
    extendPayment(payment) {
      this.extendedPayment = this.extendedPayment === payment ? '' : payment;
    },
    updateMonetarySignShowing(obj) {
      if (obj.uf === true) {
        this.monetarySignShowing = 'UF';
      } else {
        this.monetarySignShowing = 'CLP';
      }
    }
  }
};
</script>
<style scoped>
.card-item {
  overflow: visible;
}
/* header */
.card-item-header {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 2rem;
}
.card-item-header .transaction-header-resume {
  width: 100%;
  display: grid;
  grid:
    "amount payments payed status" auto
    /1fr 1fr 1fr 6rem;
  gap: 0.5rem 1rem;
  place-items: center;
}
.transaction-header-amount { grid-area: amount; }
.transaction-header-payments { grid-area: payments; }
.transaction-header-payed { grid-area: payed; }
.transaction-header-status { grid-area: status; z-index: 1; }
.card-item-header .transaction-header-resume .transaction-header-amount,
.card-item-header .transaction-header-resume .transaction-header-payments,
.card-item-header .transaction-header-resume .transaction-header-payed {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  gap: 0.3rem 0.5rem;
}
.transaction-header-payment {
  background-color: var(--color-g-inactive);
  border-radius: 1.5rem;
  padding: 0rem 0.5rem;
  margin-left: 0.3rem;
}
/* details */
.card-item-details {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.3rem;

  background-color: #F9F9F9;
  border-radius: 1.5rem;
  padding: 0rem 1.5rem;
  width: 100%;
  max-height: 0rem;
  overflow: hidden;
}
.card-item-details.show {
  max-height: 100rem;
  margin-top: 3%;
  padding: 3% 5%;
  overflow-y: auto;
  overflow: visible;
}
.details-header {
  display: flex;
  flex-flow: row wrap;
  gap: 0.3rem 1rem;
  align-content: center;
  justify-content: flex start;
}
.details-header > span{
  display: flex;
  flex-flow: row wrap;
  gap: 0rem 0.5rem;
  align-content: center;
  justify-content: flex start;
}
/* payment details */
.card-item-details .selected-operation .selected-payment {
  width:100%;
  display: flex;
  flex-flow: column wrap;
  gap: 0.2rem 1rem;
}
.selected-payment.show {
  background-color: rgb(243, 243, 243);
  border-radius: 1rem;
}
.selected-payment-details .gloss {
  display: grid;
  grid:
    "payment title monetary-sign button"
    / 5rem 1fr 0.5fr 1.2rem;
  gap: 0.5rem;
  padding: 0.2rem;
}
.detail-glosses.hide{
  max-height: 0rem;
  overflow: hidden;
}
.detail-glosses.show {
  max-height: 100rem;
  overflow-y: auto;
  overflow: visible;
  background-color: rgb(243, 243, 243);
}
.selected-payment-details .gloss .gloss-payment {
  grid-area: payment;
  place-self: center;
}
.selected-payment-details .gloss .gloss-title {
  grid-area: title;
  place-self: center start;
}
.selected-payment-details .gloss .gloss-monetary-sign {
  grid-area: monetary-sign;
  place-self: center start;
}
.selected-payment-details .gloss .gloss-button {
  grid-area: button;
  place-self: center start;
}
/* otros */
.content-title {
  color: var(--primary);
  font-weight: 600;
}
.tag {
  color: white;
}
.tag.confirmed, .tag.consignable {
  background-color: var(--primary);
}
.tag.success {
  background-color: var(--yellow);
}
.tag.pending {
  background-color: var(--yellow);
}
.tag.cancelled, .tag.fail {
  background-color: var(--color-moon);
}
.tag.rejected {
  background-color: var(--secondary);
}
.low-line {
  border-bottom: 1px solid var(--color-silver);
}
.up-line {
  border-bottom: 1px solid var(--color-silver);
  border-top: 1px solid var(--color-silver);
}
@media (max-width: 1000px) {
  .card-item-header .transaction-header-resume {
    grid:
      "amount payments status" auto
      "amount payed status" auto
      / 6rem 1fr 6rem;
  }
}
@media (max-width: 580px) {
  .card-item.shadowless {
    border-radius: 20px;
    padding: 6%
  }
  .card-item-header {
    font-size: 0.9rem;
    gap: 1rem;
  }
  .card-item-header .transaction-header-resume {
    grid:
      "amount status" auto
      "payments payments" auto
      "payed payed" auto
      / 1fr 3rem;
  }
  .transaction-header-status { justify-self: right; }
  .card-item-header .transaction-header-resume .transaction-header-amount,
  .card-item-header .transaction-header-resume .transaction-header-payments,
  .card-item-header .transaction-header-resume .transaction-header-payed {
    justify-content: left;
  }
  .card-item-details.show {
    margin: 1rem 1%;
  }
  .selected-payment-details {
    font-size: 0.7rem;
  }
}
@media (max-width: 400px) {
  .selected-payment-details {
    font-size: 0.75rem;
  }
  .card-item-details {
    font-size: 0.9rem;
  }
  .selected-payment-details .gloss {
  display: grid;
  grid:
    "payment title monetary-sign button"
    / 1rem 1fr 4rem 1rem;
}
}
</style>

<i18n>
  {
    "cl": {
      "mortgage": "Hipotecario",
      "complementary": "Complementario",
      "homeEquity": "Hipotecario",
      "parking": "",
      "sme": "SME"
    },
    "pe": {
      "mortgage": "Hipotecario",
      "complementary": "Complementario",
      "homeEquity": "Hipotecario",
      "parking": "",
      "sme": "SME"
    },
    "br": {
      "mortgage": "Hipoteca",
      "complementary": "Complementar",
      "homeEquity": "Hipoteca",
      "parking": "",
      "sme": "SME"
    }
  }
  </i18n>
